// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"LeaderCard_cardTitle__3oaHn"};